import React from 'react';

// Add CSS to hide scrollbars
const hideScrollbarStyle = `
  .no-scrollbar::-webkit-scrollbar {
    display: none;
  }
  .no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

// Inject the CSS
if (typeof document !== 'undefined') {
  const styleElement = document.createElement('style');
  styleElement.textContent = hideScrollbarStyle;
  if (!document.head.querySelector('style[data-hide-scrollbar]')) {
    styleElement.setAttribute('data-hide-scrollbar', 'true');
    document.head.appendChild(styleElement);
  }
}

interface EditableDetailsItemProps {
  label: string;
  value: string;
  isEditing: boolean;
  onChange: (value: string) => void;
  type?: 'text' | 'email' | 'tel';
  isReadOnly?: boolean;
  /** Record field this edits; lets a caller focus it (`[data-field]`). */
  fieldKey?: string;
}

const EditableDetailsItem: React.FC<EditableDetailsItemProps> = ({
  label,
  value,
  isEditing,
  onChange,
  type = 'text',
  isReadOnly = false,
  fieldKey,
}) => {
  const inputStyle = {
    background: 'var(--input-color, transparent)',
    border: '1px solid var(--Primary-400, #4895ef)',
    borderRadius: '4px',
    padding: '8px 12px',
    color: 'var(--Text-Main, var(--input-text-color))',
    WebkitTextFillColor: 'var(--Text-Main, var(--input-text-color))',
    fontSize: '14px',
    width: '100%',
    maxWidth: '100%',
    outline: 'none',
    boxSizing: 'border-box' as const,
    minHeight: '36px',
    resize: 'none' as const,
    overflow: 'hidden' as const,
    scrollbarWidth: 'none' as const,
    msOverflowStyle: 'none' as const,
  };

  return (
    <div className='hit-item' style={{ width: '100%', overflow: 'hidden' }}>
      <div
        className='hit-mains'
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: '2px',
          overflow: 'hidden',
        }}
      >
        <div
          className='hit-title'
          style={{
            color: '#4895ef',
            fontSize: '14px',
            fontWeight: '600',
            lineHeight: '18px',
          }}
        >
          {label}
        </div>
        <div
          className='hit-meta'
          style={{
            width: '100%',
            overflow: 'hidden',
            lineHeight: '12px',
            marginTop: '4px',
          }}
        >
          {isEditing && !isReadOnly ? (
            <input
              type={type}
              aria-label={label}
              data-field={fieldKey}
              value={value || ''}
              onChange={(e) => onChange(e.target.value)}
              style={inputStyle}
              placeholder={`Enter ${label.toLowerCase()}`}
              className='no-scrollbar screening-input-field-content'
            />
          ) : (
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
                lineHeight: '18px',
              }}
            >
              {value || '-'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditableDetailsItem;
